import groq from 'groq';
import {
  externalLink,
  internalLink,
  socialLink,
  ssuLink,
} from '@pkg/sanity-utils/linkQueries';

/**
 * Projection for a navigation.footers document (no `mainFooter->` wrapper).
 * Coalesce link arrays so consumers always get arrays.
 */
export const footerNavigationItems = groq`
footnote,
'pageLinks': coalesce(pageLinks[] {
  ${externalLink},
  ${internalLink},
  ${ssuLink},
}, []),
'socialLinks': coalesce(socialLinks[] {
  ${socialLink},
}, []),
'legalLinks': coalesce(legalLinks[] {
  ${externalLink},
  ${internalLink},
  ${ssuLink},
}, []),
`;
